export class NDCDetails {
    ndcId: number;
    ndcTitle: string;
    cptId: string;
    cptCode: string;
    cptPrice: string;
    cptMod: string;
    ndcCode: string;
    clinicType: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    mode: string;
    price: any;
    claimType: string;
    facilityId: number;
    activeStatus: string;
}
